import React, { Component } from 'react';
import "./index.scss";

class Chart extends Component {

    render() {
        return (
            <div className="t7_7-chart">
                <div className="list-chart">
                    <div id="row1"></div>
                    <div id="row2"></div>
                    <div id="chart1"></div>
                    <div id="chart2"></div>
                    <div id="chart3"></div>
                    <div id="chart4"></div>
                    <div id="chart5"></div>
                    <div id="chart6"></div>
                </div>
            </div>
        );
    }
}

export default Chart;


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-7/components/Chart.js